import { CoreSonarObjectsOptimisticChangeName } from './name';
import { createAddSyncSlice } from '@sonar-software/xuder';

import {
	defaultSonarObjectsOptimisticChangeState,
	SonarObjectsOptimisticChangeRequest,
	SonarObjectsOptimisticChangeState
} from './state';

export const coreSonarObjectsOptimisticChangeAddSlice = createAddSyncSlice({
	name: CoreSonarObjectsOptimisticChangeName,
	state: defaultSonarObjectsOptimisticChangeState,
	transform: (action: SonarObjectsOptimisticChangeRequest): SonarObjectsOptimisticChangeState['data'] => ({
		...action,
		sonarObjectIds: action.sonarObjectIds.reduce((ids, sonarObjectId) => ({
			...ids,
			[ sonarObjectId ]: true
		}), {})
	})
});
